import { SELECIONAR_DATA_VOLTA } from '../types';

export default function selecionarDataVolta (data) {
  return {
    type: SELECIONAR_DATA_VOLTA,
    payload: data
  }
}
